import React, { useState } from 'react';
import { ColumnConfig } from '@components/design/migrated/Table';
import { CategoryGroup, GroupState, OpportunityReviewTableContent } from '@models/OpportunityReview';
import OpportunityReviewTableCell from '../opportunity-review-table-cell/OpportunityReviewTableCell';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { useOpportunityReviewBoardGroupEventState } from '@components/opportunity-review-group/utils/OpportunityReviewBoardGroupContext';
import { getGrandTotalValue } from '@utils/TotalUtils';

interface Props {
  opportunityReviewBoardPg: OpportunityReviewTableContent;
  columns: ColumnConfig[];
  isStickyRow?: boolean;
  sortedColumn: string;
  className?: string;
  selectedGrowthType: GrowthTypes;
  currencySymbol: string;
  groupState?: GroupState;
  isPreferenceOwner?: boolean;
}

export const getKeysByOrder = (columns: ColumnConfig[]): string[] => columns.map(({ headerKey }) => headerKey);

export const isCategoryGroup = (type: string): boolean => type === CategoryGroup;

const OpportunityReviewTableRow: React.FC<Props> = ({
  opportunityReviewBoardPg,
  columns,
  isStickyRow,
  sortedColumn,
  className,
  selectedGrowthType,
  currencySymbol,
  groupState,
  isPreferenceOwner,
}) => {
  const headerKeys = getKeysByOrder(columns);
  const [isRowHovered, setIsRowHovered] = useState<boolean>(false);
  const { selectSegments, isEditGroupMode } = useOpportunityReviewBoardGroupEventState();
  const savedSelectedProductGroup = (e: React.MouseEvent<HTMLTableRowElement>) => {
    e.preventDefault();

    if (
      (isEditGroupMode.isEditMode &&
        isEditGroupMode.groupDetails.groupElement.includes(opportunityReviewBoardPg.segment)) ||
      groupState?.isGroupingProductGroup ||
      groupState?.isGroupingHeader ||
      opportunityReviewBoardPg.segment === getGrandTotalValue()
    ) {
      return;
    }

    selectSegments(opportunityReviewBoardPg.segment);
  };

  return (
    <tr
      className={className}
      onClick={(event) => savedSelectedProductGroup(event)}
      onMouseEnter={() => setIsRowHovered(true)}
      onMouseLeave={() => setIsRowHovered(false)}
    >
      {headerKeys.map((headerKey) => {
        return (
          <OpportunityReviewTableCell
            key={headerKey}
            headerKey={headerKey}
            opportunityReviewTableContent={opportunityReviewBoardPg}
            isStickyRow={isStickyRow}
            isCategoryGroup={isCategoryGroup(headerKey)}
            sortedColumn={sortedColumn}
            selectedGrowthType={selectedGrowthType}
            currencySymbol={currencySymbol}
            isRowHovered={isRowHovered}
            groupState={groupState}
            isPreferenceOwner={isPreferenceOwner}
          />
        );
      })}
    </tr>
  );
};

export default OpportunityReviewTableRow;
